"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const viewportConfig = {
    viewport: {
        preferredAppWidth: 480,
        minHalfPanelHeight: 590,
        lowResolutionWidth: 560,
        midResolutionHeight: 800,
        highResolutionHeight: 1200,
        framedModeMinMargin: 40,
        maxAppHeight: 960,
    },
};
exports.default = viewportConfig;
